export default __webpack_public_path__ + "static/media/21_Epi_GG-Quiz-Art_bakerofseville_lame_VOG.4eaae8d7.png";